var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKiro = function SvgKiro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1200 1200"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    fill: "#9046FF",
    rx: 260
  })), /*#__PURE__*/React.createElement("mask", {
    id: "kiro_svg__a",
    width: 655,
    height: 796,
    x: 272,
    y: 202,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M926.578 202.793H272.637v795.064h653.941z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#kiro_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M398.554 818.914c-82.239 182.116 92.923 227.826 222.118 121.242 38.015 119.504 180.38 30.317 231.562-62.361 112.553-204.228 67.084-412.438 55.406-455.421-80.003-292.931-480.017-293.428-548.84 1.491-16.149 51.679-16.398 110.315-25.342 171.186-4.472 30.809-7.951 50.437-19.628 82.734-6.957 18.639-16.15 35.034-31.057 62.86-22.858 43.236-13.169 126.468 105.097 83.238l11.181-4.969z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M636.123 549.353c-32.795 0-37.764-39.256-37.764-62.611 0-21.119 3.727-37.765 10.934-48.449 6.211-9.441 15.404-14.162 26.83-14.162 11.432 0 21.369 4.721 28.324 14.41 7.951 10.933 12.176 27.579 12.176 48.201 0 39.256-15.152 62.611-40.248 62.611zM771.24 549.353c-32.795 0-37.763-39.256-37.763-62.611 0-21.119 3.726-37.765 10.933-48.449 6.211-9.441 15.404-14.162 26.83-14.162 11.432 0 21.369 4.721 28.324 14.41 7.952 10.933 12.176 27.579 12.176 48.201 0 39.256-15.152 62.611-40.248 62.611z"
  }))));
};
export default SvgKiro;